module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td><input type="checkbox" '+
((__t=( checked ))==null?'':_.escape(__t))+
' class="contact_'+
((__t=( id ))==null?'':_.escape(__t))+
'" /></td>\n<td>'+
((__t=( last_name ))==null?'':_.escape(__t))+
', '+
((__t=( first_name ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( groupString ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( giftAid ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( hasJoinos ))==null?'':_.escape(__t))+
'</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/contacts/row.html
// module id = 257
// module chunks = 0